export default "__VITE_ASSET__KlO$bNO9__"